import { statusVariants } from '../const/PaymentMethodButtonConst';
import type { StatusChip } from '../type/PaymentMethodButtonTypes';

export const createDefaultStatus = (): StatusChip => ({
  ...statusVariants.defaultPaymentMethod,
  chipType: 'Default',
});

export const createManufacturerStatus = (
  medication?: string,
): StatusChip => {
  return {
    text: 'Manufacturer copay card',
    medication,
    iconName: 'localAtm',
    chipType: 'Manufacturer',
  };
};

export const createExpiredStatus = (
  expirationMonth: number,
  expirationYear: number,
): StatusChip => ({
  text: statusVariants.expiredCard.text(
    expirationMonth,
    expirationYear,
  ),
  iconName: statusVariants.expiredCard.iconName,
  chipType: 'Expired',
});

export const createInvalidStatus = (): StatusChip => ({
  ...statusVariants.invalidPaymentMethod,
  chipType: 'Invalid',
});
